<template>
	<div>
		<div class="p4 flex wrap xs-12 xs-center">
			<!-- Heading -->
			<div class="flex xs-12 xs-left">
				<p class="fs4 fw7 c6">Template Attachments</p>
			</div>

			<!-- Attachments -->
			<j-card
				v-for="(item, i) in attachedFiles"
				:key="i"
				class="flex flex-row p2 xs-12 xs-between xs-middle bg5 mt2"
			>
				<div class="xs-left">
					<h3 class="fs3 c1">{{ item.fileName }}</h3>
				</div>
				<div class="xs-right">
					<!-- TODO: preview pdf feature -->
					<!-- <j-button size="xsmall" type="secondary" class="mr2">{{$t("preview")}}</j-button> -->
					<j-button
						size="xsmall"
						type="secondary"
						class="mr2"
						@click="showRenameModal(item)"
					>{{ $t("rename") }}</j-button>
					<j-button
						size="xsmall"
						type="error"
						class="mr2"
						@click="removeAttachment(item)"
					>{{ $t("remove") }}</j-button>
				</div>
			</j-card>
			<j-card class="flex flex-row p2 xs-12 xs-center xs-middle bg5 mt2">
				<j-button size="xsmall" @click="$modal.show('add_template_attachment')">
					{{
					$t("add_attachment")
					}}
				</j-button>
			</j-card>
		</div>

		<!-- Add Attachment Modal -->
		<core-modal
			name="add_template_attachment"
			:headline="$t('add_attachment')"
			@close="selectedAttachments = []"
		>
			<div class="pl4 pr4 pt4 mb2 flex xs-between xs-middle">
				<span class="fs4 fw7">{{ $t("select_template") }}</span>
				<j-button
					type="tertiary"
					@click="$router.push({name: 'PdfTemplatesCreate'})"
				>{{ $t("create_template") }}</j-button>
			</div>

			<div class="flex wrap xs-12 pl4 pr4 pb4 xs-right">
				<!-- Search -->
				<j-base-multi-select-with-flexible-value
					:options="options"
					:placeholder="$t('select_template')"
					:allowLocalSearch="true"
					:allowMultiselect="true"
					valueKey="id"
					nameKey="name"
					:value="null"
					@input="onInput($event)"
				/>

				<!-- Selected Attachments -->
				<div class="flex wrap xs-12 overflow">
					<j-card
						v-for="(item, i) in selectedAttachments"
						:key="i"
						class="flex xs-12 xs-between xs-middle fs3 c6 p4 bg5 mt1"
					>
						<div>{{ item.name }}</div>
						<div>
							<crm-icon
								color="c6"
								size="small"
								name="cross"
								class="cu2"
								@click.native="removeSelectedAttachment(i)"
							/>
						</div>
					</j-card>
				</div>

				<!-- Add Selected Attachments -->
				<j-button
					class="mt2"
					size="small"
					@click="addAttachment"
					v-if="selectedAttachments.length > 0"
				>
					{{
					$t("add_attachment")
					}}
				</j-button>
			</div>
		</core-modal>

		<!-- Update Attachment Modal -->
		<core-modal
			name="rename_template_attachment"
			:headline="$t('rename_attachment')"
		>
			<div class="flex wrap xs-12 p4 bg5 xs-right">
				<core-form-input
					name="fileName"
					componentName="j-base-input-text"
					v-model="updateInput.fileName"
				/>
				<j-button class="mt2" @click="updateAttachment(updateInput)">
					{{
					$t("update")
					}}
				</j-button>
			</div>
		</core-modal>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"
import JCard from "@/components/JCard"
import CoreModal from "@/modules/core/components/CoreModal"
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JBaseMultiSelectWithFlexibleValue from "@/components/JBaseMultiSelectWithFlexibleValue"

import api from "../../../api"
import get from "lodash.get"

export default {
	components: {
		JButton,
		CrmIcon,
		JCard,
		CoreModal,
		CoreFormInput,
		JBaseMultiSelectWithFlexibleValue
	},

	props: {
		// list of possible attachments
		options: Array,
		// attachments already attached to this template
		attachedFiles: Array
	},

	data() {
		return {
			selectedAttachments: [],
			updateInput: {
				fileName: null,
				attachmentTemplateId: null
			}
		}
	},

	methods: {
		async addAttachment() {
			const res = await Promise.all(
				this.selectedAttachments.map(item =>
					api.addEmailAttachmentTemplate({
						templateId: this.$route.params.id,
						input: {
							fileName: `${item.name}.pdf`,
							templateId: item.id
						}
					})
				)
			)

			if (res.errors) this.$store.dispatch("showError", res.errors)
			else
				this.$store.dispatch("addMessage", {
					message: {
						type: "success",
						text: this.$t("attachments_added")
					}
				})

			this.$modal.hide("add_template_attachment")

			this.$emit("added:attachment")
		},

		async removeAttachment(payload) {
			const res = await api.removeEmailAttachmentTemplate({
				templateId: this.$route.params.id,
				attachmentTemplateId: payload.attachmentTemplateId
			})

			if (res.errors) this.$store.dispatch("showError", res.errors)

			this.$emit("removed:attachment")
			this.$store.dispatch("addMessage", {
				message: {
					type: "success",
					text: this.$t("attachment_removed")
				}
			})
		},

		removeSelectedAttachment(index) {
			this.selectedAttachments.splice(index, 1)
		},

		showRenameModal(payload) {
			this.updateInput.fileName = payload.fileName
			this.updateInput.attachmentTemplateId = payload.attachmentTemplateId
			this.$modal.show("rename_template_attachment")
		},

		async updateAttachment(payload) {
			const res = await api.updateEmailAttachmentTemplate({
				templateId: this.$route.params.id,
				input: {
					...this.updateInput
				}
			})

			if (res.errors) this.$store.dispatch("showError", res.errors)
			else
				this.$store.dispatch("addMessage", {
					message: {
						type: "success",
						text: this.$t("attachment_renamed")
					}
				})

			this.$modal.hide("rename_template_attachment")
			this.$emit("updated:attachment")
		},

		onInput(value) {
			this.selectedAttachments.push(...value)
		}
	}
}
</script>

<style scoped>
.overflow {
	overflow: scroll;
	align-items: flex-start;
	align-content: flex-start;
	height: 300px;
}
</style>
